module.exports = __webpack_public_path__ + "static/img/icon1-9.e149ca42.png";